import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from "@/router"
import "./common/rem.js"
import storage from '@/utils/storage.js'
import http from '@/utils/http.js'
Vue.config.productionTip = false;
Vue.prototype.$storage = storage;
Vue.prototype.$http = http;
Vue.use(VueRouter);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
